export default {
  call: 'Gọi',
  text: 'Nhắn tin',
}
